import { render, staticRenderFns } from "./RedirectionUrl.vue?vue&type=template&id=4a5ac324"
import script from "./RedirectionUrl.vue?vue&type=script&lang=js"
export * from "./RedirectionUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports